import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    // console.log("location:"+location.pathname)
  }, [location]);

  return <>{children}</>;
};

export default ScrollToTop;
